module.exports = __webpack_public_path__ + "static/media/thumbnail.fd2528c7.jpg";